const LocalStorageConstants = {
  LOCAL_STORAGE_TOKEN: "token",
  LOCAL_REFRESH_TOKEN: "refresh_token",
  LOCAL_STORAGE_USER: "user",
};

export default LocalStorageConstants;
